module.exports = __webpack_public_path__ + "img/arrow_down.c74f4fa5.svg";